import useSWR from 'swr';
import { core } from '@mentimeter/http-clients';

export function useTemplateCategories() {
  return useSWR('/api/public-templates/categories', async () => {
    const { data } = await core().publicTemplates.categories.get();
    return data.data;
  });
}
